import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HistoryEntry {
  timestamp: string;
  symptoms: string[];
}

interface AIState {
  selectedSymptoms: string[];
  history: HistoryEntry[]; // NEW
}

const initialState: AIState = {
  selectedSymptoms: [],
  history: JSON.parse(localStorage.getItem("ai_history") || "[]"), // NEW
};

export const aiAgentSlice = createSlice({
  name: "aiAgent",
  initialState,
  reducers: {
    toggleSymptom: (state, action: PayloadAction<string>) => {
      if (state.selectedSymptoms.includes(action.payload)) {
        state.selectedSymptoms = state.selectedSymptoms.filter(
          (s) => s !== action.payload
        );
      } else {
        state.selectedSymptoms.push(action.payload);
      }
    },

    clearSymptoms: (state) => {
      state.selectedSymptoms = [];
    },

    // NEW: Add history entry to Redux + localStorage
    addHistory: (state, action: PayloadAction<HistoryEntry>) => {
      state.history.unshift(action.payload);
      localStorage.setItem("ai_history", JSON.stringify(state.history));
    },
  },
});

export const { toggleSymptom, clearSymptoms, addHistory } = aiAgentSlice.actions;
export default aiAgentSlice.reducer;
